module.exports = __webpack_public_path__ + "static/media/TinySmile_72dpi.96140bf7.png";